import React from 'react'
import { FundAffectation } from '../../../models/Portfolio'
import { Box, ITheme, IconButton, Typography, useTheme } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../store/reducers/store';
import { Utilities } from '../../../utility/utils';
import RemoveIcon from '@mui/icons-material/Remove';
import { removeFundToPortfolio } from '../../../store/actions/createPortfolio';
import { LeoImagesFundsPath } from '../../../resources/api-constants';
import { useTranslation } from 'react-i18next';

export interface IFundSelectionListItemProps {
    fund: FundAffectation;
    index: number;
    hideRemove?: boolean;
    allocation?: number;
}

const FundSelectionListItem: React.FC<IFundSelectionListItemProps> = ({ fund, index, hideRemove, allocation }) => {
    const theme = useTheme() as ITheme;
    const funds = useAppSelector(state => state.libraryOfFundsReducer.allFunds);
    const dispatch = useAppDispatch();
    const match = funds && funds.find(f => f.id === fund.id);
    const { t } = useTranslation();

    if (match === undefined) {
        return <></>;
    }

    const removeFund = () => {
        dispatch(removeFundToPortfolio(fund.id));
    }

    return <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} borderRadius={"4px"} padding={"2px 14px"} boxShadow={theme.shadows[1]} gap={"21px"}>
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"}>{index + 1}.</Typography>
        <img src={`${LeoImagesFundsPath}/${match.logo}`} style={{ width: "100px", height: "24px", objectFit: "contain"}} />
        <Typography fontSize={"14px"} lineHeight={"17.07px"} fontWeight={"500"} sx={{ flexGrow: 1}}>{match.name}</Typography>
        <Box display={"flex"} gap={"4px"} alignItems={"center"}>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"600"}>{`€${Utilities.toFriendlyMoneyValue(allocation !== undefined ? allocation : match.fundSize)}`}</Typography>
            <Typography fontSize={"12px"} lineHeight={"14.63px"} fontWeight={"500"}>{t(allocation !== undefined ? 'LibraryOfFundsAllocated' : 'LibraryOfFundsFundSize')}</Typography>
        </Box>

        {!hideRemove && <IconButton size='small' onClick={removeFund}>
            <RemoveIcon fontSize='small' sx={{ color: theme.palette.text.primary }} />
        </IconButton>}
    </Box>
}

export default FundSelectionListItem